import { IComponentOptions, IController, IWindowService } from 'angular';
import { Transition } from '@uirouter/angularjs';
import { ORDER_SUCCESS } from '../../constants/message-types';

export class PaymentRedirectController implements IController {
  static $inject = [
    '$window'
  ];
  $transition$: Transition;

  constructor( private $window: IWindowService ) {
  }

  $onInit() {
    const order = this.$transition$.params().order;
    this.$window.parent.postMessage({ type: ORDER_SUCCESS, order }, '*');
  }
}

export const PaymentRedirectComponent: IComponentOptions = {
  controller: PaymentRedirectController,
  bindings: {
    $transition$: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states_mobile/payment-process/components/payment-redirect/payment-redirect.component.ts